// gimme: conversations-inbox-ui 05/26/2020 741c62dc71ca742adbc6d64d61d30de7cb46539f
'use es6';

import get from 'transmute/get';
export const shouldShowDeletedMessages = ({
  deletedMessages,
  threadId
}) => get(threadId, deletedMessages);